<app-app-header></app-app-header>
<router-outlet />
@if (maintenanceStatus$ | async) {
  <main style="display: flex; align-items: center; justify-content: center; gap:10px; flex-direction: column;">
    <h1>Estamos a carregar o formulário</h1>
    <app-loading-spinner></app-loading-spinner>
  </main>
}
<app-app-footer></app-app-footer>
